import Vue from 'vue'

// Le backend répond en HTTP 200 même quand la route échoue ({ status: 'error', message }),
// donc $srvApi.Req résout au lieu de rejeter. Sans ce contrôle, un refus serveur
// (connexion non enregistrée) s'affichait comme un succès.
async function req(method, url, data) {
    const rep = await Vue.prototype.$srvApi.Req(method, url, data);
    if (!rep || rep.status !== 'success')
        throw new Error((rep && rep.message) || 'Erreur serveur Meta');
    return rep;
}

class MetaLead {
    /**
     * Sauvegarder la connexion Meta + pages sélectionnées
     * Le backend s'occupe d'activer les webhooks automatiquement
     */
    static async saveConnection(data) {
        return await req('post', 'meta/connection', data);
    }

    /**
     * Récupérer la connexion Meta et les pages connectées
     */
    static async getConnection() {
        return await req('get', 'meta/connection');
    }

    /**
     * Déconnecter le compte Meta (supprime pages + webhooks)
     */
    static async disconnect() {
        return await req('delete', 'meta/connection');
    }

    /**
     * Déconnecter une seule page sans supprimer le compte
     */
    static async disconnectPage(pageId) {
        return await req('delete', 'meta/connection/page/' + pageId);
    }

    /**
     * Importer manuellement les leads existants d'une page (API Meta — nécessite pages_manage_ads)
     */
    static async importLeads(pageId) {
        return await req('post', 'meta/import-leads/' + pageId);
    }

    /**
     * Importer l'historique des prospects depuis un fichier CSV/Excel exporté de Meta.
     * `leads` = tableau d'objets { first_name, last_name, email, phone } (envoyé par lots).
     */
    static async importCsv(leads) {
        return await req('post', 'meta/import-csv', { leads });
    }
}

export default MetaLead;
